<template>
  <section class="p-1">
    <!-- <bread-crumb :bread-crumbs="['Compliance', 'List of Customers']" /> -->

    <v-card class="">
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 subtitle-1">Transaction Details</div>
        <div>
          <bread-crumb :bread-crumbs="['Transaction Details']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <v-simple-table class="w-100 px-2" dense>
        <tbody>
          <tr>
            <td><b>PIN NO :</b> 09877665544</td>
            <td colspan="3"><b>TRANS ID :</b> 143244</td>
          </tr>
          <tr>
            <td>Bank Transfer</td>
            <td>Status</td>
            <td colspan="2">Post</td>
          </tr>
          <tr>
            <td>Generated By:</td>
            <td>Payout Partner</td>
            <td colspan="2"></td>
          </tr>
          <tr>
            <td>Web</td>
            <td colspan="3">India</td>
          </tr>
          <tr>
            <td>Approved:</td>
            <td>Paid By</td>
            <td colspan="2"></td>
          </tr>
          <tr>
            <th>Sender Name</th>
            <td>Sumanth Chevuru</td>
            <th>Beneficiary Name</th>
            <td>Sumanth Chevuru</td>
          </tr>
          <tr>
            <th colspan="2">Transaction Information</th>
            <th colspan="2">Cost Rate</th>
          </tr>
          <tr>
            <td>Collected Amount</td>
            <td>100 MYR</td>
            <td>100 MYR</td>
            <td>100 MYR</td>
          </tr>
          <tr>
            <td>Service Charge</td>
            <td>100 MYR</td>
            <td>100 MYR</td>
            <td>100 MYR</td>
          </tr>
          <tr>
            <td>Additional Fee</td>
            <td>100 MYR</td>
            <td>100 MYR</td>
            <td>100 MYR</td>
          </tr>
          <tr>
            <td>Transfer Amount</td>
            <td>100 MYR</td>
            <td>100 MYR</td>
            <td>100 MYR</td>
          </tr>
          <tr>
            <td>Exchange Rate</td>
            <td>100 MYR</td>
            <td>100 MYR</td>
            <td>100 MYR</td>
          </tr>
          <tr>
            <td>Payout Amount</td>
            <td>100 MYR</td>
            <td>100 MYR</td>
            <td>100 MYR</td>
          </tr>
          <tr>
            <th colspan="2">Send Partner Settlment</th>
            <th colspan="2">Payout Partner Settlement</th>
          </tr>
          <tr>
            <td>Settlement Rate</td>
            <td>100 MYR</td>
            <td>Payout Amount</td>
            <td>100 MYR</td>
          </tr>
          <tr>
            <td>Partner Ex Gain</td>
            <td>100 MYR</td>
            <td>Fee Commision</td>
            <td>100 MYR</td>
          </tr>
          <tr>
            <td>Partner Comission</td>
            <td>100 MYR</td>
            <td>Comission Share By Send CCY Fee</td>
            <td>100 MYR</td>
          </tr>
          <tr>
            <td>Cost Rate</td>
            <td>100 MYR</td>
            <td>Settlemant Rate</td>
            <td>100 MYR</td>
          </tr>
          <tr>
            <td>Net Settlement LCY</td>
            <td>100 MYR</td>
            <td>Net Settlement LCY</td>
            <td>100 MYR</td>
          </tr>
          <tr>
            <td>Net Settlement USD</td>
            <td>100 MYR</td>
            <td>Net Settlement USD</td>
            <td>100 MYR</td>
          </tr>
        </tbody>
      </v-simple-table>
      <!-- <v-simple-table class="w-100 px-2" dense>
        <tbody>
          <tr>
            <td colspan="2">Send Partner Settlment</td>
            <td colspan="2">Payout Partner Settlement</td>
          </tr>
        </tbody>
      </v-simple-table> -->
    </v-card>
  </section>
</template>

<script>
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
export default {
  name: "Transaction Details",
  data: () => {
    return {};
  },
  components: {
    BreadCrumb,
    // listOverviewVue
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    async downloadExcelsheet() {
      if (this.userList) {
        this.exportToExcel(this.headers, this.userList, "List of customers");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/global.scss";

tr:nth-child(even) {
  background-color: $background-color;
}

// tr:hover {
//   background: none !important;
// }
th {
  text-transform: uppercase;
}
</style>
